import { render, staticRenderFns } from "./AnchorNav.vue?vue&type=template&id=51213284&scoped=true&"
import script from "./AnchorNav.vue?vue&type=script&lang=ts&"
export * from "./AnchorNav.vue?vue&type=script&lang=ts&"
import style0 from "./AnchorNav.vue?vue&type=style&index=0&id=51213284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51213284",
  null
  
)

export default component.exports